import { Card, CardContent, CardMedia, Stack, Typography } from '@mui/material'
import { DeviceSpec } from '../types/models'

interface DeviceSpecCardProps {
  spec: DeviceSpec | null
}

export function DeviceSpecCard(props: DeviceSpecCardProps): React.ReactElement {

  const { spec } = props

  if (!spec) return <></>

  return (
    <Card sx={{
      border: '1px solid rgba(255, 255, 255, 0.23)',
      p: 2,
      m: 2,
      display: 'flex',
      flexDirection: 'row',
      justifyContent: 'space-between',
    }}>
      <CardContent sx={{ display: 'flex', color: '#fff' }}>
        <Stack>
          <Typography gutterBottom variant="h5" component="div">
            {spec.manufacturer} {spec.model}
          </Typography>
          <Typography variant="body2" color="text.secondary">
            {spec.description}
          </Typography>
        </Stack>
      </CardContent>
      <CardMedia
        sx={{ display: 'flex', width: 150 }}
        component="img"
        image={`/api/v1/device-specs/${spec.id}/picture`}
      />
    </Card>
  )
}
